import {SortDirection} from '@angular/material/sort/sort-direction';

export class SortModel {
  active: string;
  direction: SortDirection;
}
